import styled from 'styled-components';

export const StartDateWrapper = styled.div`
  .valid-message {
    .ant-form-item-explain-error {
      margin-top: -80px;
    }
  }
`;
